import React, { useMemo } from 'react';
import { Button } from '@attentive-platform/stem-ui';

export default function SOPTradeCard({ trade, idx, collapsed, handleCollapse, handleRemoveTrade, handleCheckbox, handleNotes, handleSelectAllInTrade }) {
  // Build a map of all included and additional scopes for this trade
  const includedScopesMap = {};
  [...(trade.assigned_included_scopes || []), ...(trade.remaining_included_scopes || [])].forEach(item => {
    includedScopesMap[item.id] = item;
  });
  const additionalScopesMap = {};
  [...(trade.assigned_additional_scopes || []), ...(trade.remaining_additional_scopes || [])].forEach(item => {
    additionalScopesMap[item.id] = item;
  });

  // Memoize the additional scopes list
  const additionalScopesList = useMemo(
    () => [
      ...(trade.assigned_additional_scopes || []),
      ...(trade.remaining_additional_scopes || [])
    ],
    [trade.assigned_additional_scopes, trade.remaining_additional_scopes]
  );

  return (
    <div className='mb-3 border rounded trade-card sop-trade-card' key={trade.trade_id}>
      <div
        className='trade-card-header d-flex justify-content-between align-items-center sop-trade-card-header'
        onClick={() => handleCollapse(idx)}
      >
        <span>{trade.trade_name}</span>
        <div className='actions d-flex align-items-center'>
          {(() => {
            const totalAssigned = ((trade.assigned_included_scopes || []).length + (trade.assigned_additional_scopes || []).length);
            const totalRemaining = ((trade.remaining_included_scopes || []).length + (trade.remaining_additional_scopes || []).length);
            const allSelected = totalAssigned > 0 && totalRemaining === 0;
            return (
              <Button
                color='primary'
                size='small'
                variant='text'
                onClick={e => { e.stopPropagation(); handleSelectAllInTrade(idx, !allSelected); }}
              >
                {allSelected ? 'Deselect all items' : 'Select all items'}
              </Button>
            );
          })()}
          <Button color='error' size='small' variant='text' onClick={e => { e.stopPropagation(); handleRemoveTrade(idx); }}>
            Remove
          </Button>
          <span className='sop-trade-card-arrow'>{collapsed[idx] ? '►' : '▼'}</span>
        </div>
      </div>
      {!collapsed[idx] && (
        <div className='trade-card-body sop-trade-card-body'>
          <div className='checkbox-group mb-3'>
            <div className='sop-section-heading'>Included Items</div>
            {(trade.included_scopes_order || []).map(id => {
              const item = includedScopesMap[id];
              if (!item) return null;
              return (
                <div className='form-check mb-2 checkbox-item sop-checkbox-item' key={item.id}>
                  <input
                    className='form-check-input sop-checkbox-input'
                    type='checkbox'
                    id={`${trade.trade_id}-included-${item.id}`}
                    checked={!!(trade.assigned_included_scopes || []).find(i => i.id === item.id)}
                    onChange={() => handleCheckbox(idx, 'included', item.id)}
                    style={{ marginRight: 10 }}
                  />
                  <label className='form-check-label sop-checkbox-label' htmlFor={`${trade.trade_id}-included-${item.id}`}>
                    <span>{item.name}</span>
                  </label>
                </div>
              );
            })}
          </div>
          {additionalScopesList.length > 0 && (
            <div className='checkbox-group mb-3'>
              <div className='sop-section-heading'>Additional Details</div>
              {(trade.additional_scopes_order || []).map(id => {
                const item = additionalScopesMap[id];
                if (!item) return null;
                return (
                  <div className='form-check mb-2 checkbox-item sop-checkbox-item' key={item.id}>
                    <input
                      className='form-check-input sop-checkbox-input'
                      type='checkbox'
                      id={`${trade.trade_id}-additional-${item.id}`}
                      checked={!!(trade.assigned_additional_scopes || []).find(i => i.id === item.id)}
                      onChange={() => handleCheckbox(idx, 'additional', item.id)}
                      style={{ marginRight: 10 }}
                    />
                    <label className='form-check-label sop-checkbox-label' htmlFor={`${trade.trade_id}-additional-${item.id}`}>
                      <span>{item.name}</span>
                    </label>
                  </div>
                );
              })}
            </div>
          )}
          <div className='form-group mb-3' style={{ marginTop: 20 }}>
            <div className='sop-notes-label'>Customer-Specific Notes</div>
            <textarea
              className='form-control w-100 sop-notes-textarea'
              rows={3}
              value={trade.notes || ''}
              onChange={e => handleNotes(idx, e.target.value)}
            />
          </div>
        </div>
      )}
    </div>
  );
} 